import { CONSENT } from '@sklik/cmp2-common';
import { COOKIE, URL } from '@iva/utils';
import { cutParamFromUrl } from './utils/cutParamFromUrl.js';
import { debug } from './utils/debug.js';
import { getConsentCookieOptions } from './utils/cookieUtils.js';
import {
  CONSENT_BLACKLIST,
  CONSENT_DETECTION_TIMEOUT,
  PARAM_NAMES,
  SCMP_SSP_EVENT,
  SCMP_SSP_INTERNAL,
} from '../config.js';

/**
 * Saves consent for future use.
 * @param {String} consent - User's consent.
 */
const storeConsent = (value) => COOKIE.setCookie(CONSENT.CONSENT_COOKIE_NAME, value, getConsentCookieOptions());

/**
 * Returns whether consent should be stored or not.
 * @param {Object} cmpDataObject Object stored by SSP.
 * @return {Boolean}
 */
const shouldStore = (cmpDataObject) => {
  if (!cmpDataObject || typeof cmpDataObject !== 'object') {
    return false;
  }
  if (cmpDataObject.startDate && cmpDataObject.showDialog) {
    return true;
  }
  return false;
};

/**
 * Retrieves consent from URL and then stores it, if the website wants it.
 * @param {*} url - window.location.href
 */
export const handleConsent = (url) => {
  const consent = cutParamFromUrl(url, PARAM_NAMES.CONSENT);

  // blacklist
  const domain = URL.getDomainLevel(undefined, undefined, false);
  if (CONSENT_BLACKLIST.includes(domain)) {
    debug(`consent handler stoped, domain "${domain}" is blacklisted.`);
    return;
  }

  if (!consent) {
    debug({ message: 'did not get consent, or invalid consent (from url)', consent });
    return;
  }

  debug({ message: 'got consent from url, waiting for approval to store', consent });

  if (shouldStore(window[SCMP_SSP_INTERNAL])) {
    debug('Received approval to store synchronously, storing consent');
    storeConsent(consent);

    // all done, return
    return;
  }

  const callback = (e) => {
    if (!e.detail) {
      debug('warn', `Received "${SCMP_SSP_EVENT}" event without any data`);
      return;
    }
    if (shouldStore(e.detail)) {
      debug('Received approval from event, storing consent');
      storeConsent(consent);
    } else {
      debug('This website does not want our consent, NOT storing');
    }
    window.removeEventListener(SCMP_SSP_EVENT, callback);
  };

  window.addEventListener(SCMP_SSP_EVENT, callback);
  setTimeout(() => window.removeEventListener(SCMP_SSP_EVENT, callback), CONSENT_DETECTION_TIMEOUT);
};
